module.exports = __webpack_public_path__ + "static/img/center_img1.3c9be1b9.png";